import * as Sentry from '@sentry/react'
import { useQueryClient } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'

import { useAuth } from '@repo/common/queries/auth'

import { router } from './routes'

dayjs.extend(timezone)

export function get_environment() {
  if (window.location.hostname == 'tower.fission.xyz') {
    return 'production'
  } else if (window.location.hostname.includes('testnet')) {
    return 'testnet'
  } else if (window.location.hostname.includes('stage')) {
    return 'stage'
  }
  return 'development'
}

// no localhost error tracking
if (import.meta.env.MODE != 'development') {
  Sentry.init({
    environment: get_environment(),
    dsn: 'https://c37aafd07041a9f329aa4bff588233c3@o4507572175241216.ingest.us.sentry.io/4508994513338368',
    enableLogs: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
      Sentry.thirdPartyErrorFilterIntegration({
        filterKeys: ['fission'],

        behaviour: 'apply-tag-if-contains-third-party-frames',
      }),
      Sentry.consoleLoggingIntegration(),
      Sentry.httpClientIntegration({
        failedRequestTargets: [/g.alchemy.com/],
      }),
      Sentry.graphqlClientIntegration({
        endpoints: ['https://api.goldsky.com/', /\/graphql$/],
      }),
      Sentry.tanstackRouterBrowserTracingIntegration(router),
      Sentry.feedbackIntegration({
        colorScheme: 'dark',
        autoInject: false,
        isEmailRequired: true,
        useSentryUser: {
          name: 'name',
          email: 'email',
        },
      }),
    ],
    release: __VERSION__,
    // Performance Monitoring
    tracesSampleRate: 0.1, //  Capture 10% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [/.*.fission.xyz/],
    // Session Replay
    replaysSessionSampleRate: 0.01, // This sets the sample rate at 1%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  })
}

export function App() {
  const queryClient = useQueryClient()
  const { data: auth } = useAuth()

  return (
    <RouterProvider
      router={router}
      context={{
        queryClient,
        auth,
      }}
    />
  )
}
